module.exports = __webpack_public_path__ + "static/media/boom.791f4fbc.png";